// This icon file is generated automatically.
var PTimeCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }, { "tag": "path", "attrs": { "d": "M9.73 8.98L7.5 7.37V3.5a.13.13 0 00-.12-.13h-.75a.13.13 0 00-.13.13v4.3c0 .04.02.08.05.1L9.14 9.8c.05.04.13.03.17-.03l.45-.6a.12.12 0 00-.03-.18z" } }] }] }, "name": "p-time-circle", "theme": "outlined" };
export default PTimeCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PTimeCircleOutlined.js
// module id = 3691
// module chunks = 0